<template>
  <v-hover v-slot="{ hover }">
    <v-card
      :width="width"
      :height="height"
      :max-width="maxWidth"
      :max-height="maxHeight"
      @click="click"
    >
      <v-img
        class="white--text align-end"
        :src="`${item.public_link}?thumb=1`"
        contain
      >
      </v-img>

      <slot />

      <slot
        name="actions"
        v-bind:hover="hover"
      />
    </v-card>
  </v-hover>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
    },

    width: {
      type: [Number, String],
      default: 'auto',
    },

    height: {
      type: [Number, String],
      default: 'auto',
    },

    maxWidth: {
      type: [Number, String],
      default: 'auto',
    },

    maxHeight: {
      type: [Number, String],
      default: 'auto',
    },
  },
  name: 'ImageCard',
  data: () => ({
  }),
  methods: {
    click() {
      this.$emit('click');
    },
  },
};
</script>
